import { Component } from '../jsti/core';
import Notifications from '../constants/Notifications';
import Time from '../constants/Time';

export default class CarouselSliders extends Component {
  index: number = 0;
  timeout: function;
  /**
   * Instantiate the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    const defaultIndex = +this.el.dataset.index;
    if (defaultIndex) {
      this.index = defaultIndex;
    }

    this.addListener(Notifications.CAROUSEL_CHANGE_INDEX, this.updateIndex.bind(this));
  }

  /**
   *
   */
  updateIndex({ index, id }: { index: number, id: ?string }) {
    if (this.index === index) return;
    this.notify(Notifications.CAROUSEL_UPDATE_NAVIGATION, { index: index });

    this.notify(Notifications.CAROUSEL_SCROLL_SLIDER, { index: index, id: id });
    this.index = index;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.notify(Notifications.CAROUSEL_ADD_SCROLL_LISTENER);
    }, Time.SECOND_IN_MILLISECONDS);
  }
}
